import React from 'react';
import { SearchIcon } from '@heroicons/react/solid';
import OrganizationView from './OrganizationView';
import OrganizationList from './OrganizationList';

const Sidebar: React.FunctionComponent<any> = ({points, selectedPoint, onClick, onSearch, removePoint, news}) => {
  const [organizationListArray, setorganizationListArray] =  React.useState<any>(null);
  const searchInput = React.useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = React.useState<string | undefined>('');
  React.useEffect(() => {
    setorganizationListArray(points);
  }, [points])

  React.useEffect(() => {
    if (selectedPoint) {
      setSearchTerm('');
    }
  },[selectedPoint]);
  
  const handleChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
    event?.preventDefault();
    setSearchTerm(event?.target.value)
  };

  const onSubmit = (e:React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSearch(searchTerm);
  };

  return (
    <aside className="md:max-w-lg	md:w-3/6 xl:w-2/6 md:h-screen md:pt-6 bg-maf-black">
      <form id="search-container" className="w-full pt-2.5 px-2.5 z-10 absolute top-0 left-0 md:px-6 md:static" onClick={onSubmit}>
        <div className="flex items-center border border-white py-1">
          <input value={searchTerm} onChange={handleChange} required ref={searchInput}  id="search" name="search" type="text" className="flex-1 font-overpass-mono color-white font-bold text-lg px-4 py-1 mt-0.5 outline-none leading-none bg-transparent" placeholder="SEARCH" autoComplete="off" />
          <button className="flex-none p-2.5 border-l border-white" type="submit">
            <SearchIcon className="h-5 w-5" />
          </button>
        </div>
        { !selectedPoint && 
          <label htmlFor="search" className="text-sm my-3 block leading-none font-overpass">Search by location or organization.</label>
        }
      </form>
      { !selectedPoint && 
        <>  
        {organizationListArray?.length > 0 && 
          <OrganizationList onClick={onClick} organizations={ organizationListArray } />
        }
        {(organizationListArray?.length === 0 && searchInput.current?.value) && 
          <p className="p-6 text-center font-bold text-lg">Unable to find results for "{searchInput.current?.value}".</p>
        }
        </>
      }
      { selectedPoint && 
        <React.Fragment>
          <div className="px-2.5 md:px-6 py-3 md:pt-0 mt-4">
            <button onClick={() => removePoint()} className="text-sm leading-none outline-none flex items-center font-overpass">
              <svg className="mr-2" width="5px" height="18px" viewBox="0 0 5 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
                      <g id="Map-2" transform="translate(-68.000000, -104.000000)" stroke="#FFFFFF" strokeWidth="0.5">
                          <polyline id="Path" transform="translate(70.500000, 113.000000) rotate(90.000000) translate(-70.500000, -113.000000) " points="62 111 70.6446875 115 79 111"></polyline>
                      </g>
                  </g>
              </svg> 
              <span className="underline">Back to Results</span>
            </button>
          </div>
          <OrganizationView news={news?.filter((item: any) => item.organization_name.toLowerCase() === selectedPoint.organization_name.toLowerCase())} details={selectedPoint} />
        </React.Fragment>
      }
    </aside>
  )
}

export default Sidebar;